import styled from 'styled-components';
import { getSpacing } from 'stylesheet';
export var EmptyField = styled.div.withConfig({
  displayName: "FormBuilderstyle__EmptyField",
  componentId: "sc-m0ezvp-0"
})([""]);
export var FieldContainer = styled.div.withConfig({
  displayName: "FormBuilderstyle__FieldContainer",
  componentId: "sc-m0ezvp-1"
})(["width:inherit;margin:", " auto;"], getSpacing(2.5));